import I18n from 'I18n';
import { Select } from 'foundations-components/transitional/components/Select';
import { CATEGORY_TYPE, SUB_CATEGORY_TYPE } from '../../constants/edit/CategorizeConstants';
import { SCREENS } from '../../constants/TrackingConstants';
import UsageTracker from '../../utils/UsageTracker';
import { useListingLibQuickFilters, useGetQuickFilterValue } from 'framework-listing-lib/hooks/useQuickFilters';
import { EQ } from 'framework-listing-lib/utils/filters';
import { useCallback, useState } from 'react';
import { FILTER_CONFIG_PROPERTIES } from '../constants/actionGroups';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI';
const I18N_FILTER_PREFIX = `${I18N_PREFIX}.shared.filters`;
const MENU_WIDTH_WIDE = 360;
const getCategoriesDropDownOptions = (categories, type) => {
  let options = [];
  if (categories && categories.count() > 0) {
    if (type === CATEGORY_TYPE) {
      options.push({
        dropdownClassName: type,
        dropdownText: I18n.text(`${I18N_FILTER_PREFIX}.selectAllCategories`),
        text: I18n.text(`${I18N_FILTER_PREFIX}.default`),
        value: 0
      });
    }
    categories.forEach(category => {
      const {
        id,
        name,
        subcategories
      } = category;
      options.push({
        dropdownClassName: type,
        text: name,
        value: id
      });
      options = options.concat(getCategoriesDropDownOptions(subcategories, SUB_CATEGORY_TYPE));
    });
  }
  return options;
};
const ArticleCategoryFilter = ({
  categories
}) => {
  const {
    removeQuickFilter,
    setQuickFilter
  } = useListingLibQuickFilters();
  const getQuickFilterValue = useGetQuickFilterValue();
  const [selectedValueText, setSelectedValueText] = useState('');

  // Get current category and subcategory values
  const categoryValue = getQuickFilterValue(FILTER_CONFIG_PROPERTIES.CATEGORY_ID);
  const subcategoryValue = getQuickFilterValue(FILTER_CONFIG_PROPERTIES.SUBCATEGORY_ID);

  // Combine both values to determine the currently selected value
  const selectedValue = subcategoryValue || categoryValue || 0;
  const options = getCategoriesDropDownOptions(categories.toList(), CATEGORY_TYPE);
  const handleSelectCategory = useCallback(({
    currentTarget
  }) => {
    var _options$find;
    // All ids we set here are numbers anyways
    const value = Number(currentTarget.value);
    // Reset the filter from both properties
    removeQuickFilter('hs_knowledge_category_id');
    removeQuickFilter('hs_knowledge_subcategory_id');
    const selectedOption = options.find(option => option.value === value) || {
      dropdownClassName: null,
      text: null,
      value: null
    };
    const propertyName = selectedOption.dropdownClassName === CATEGORY_TYPE ? FILTER_CONFIG_PROPERTIES.CATEGORY_ID : FILTER_CONFIG_PROPERTIES.SUBCATEGORY_ID;
    if (value !== 0) {
      setQuickFilter(EQ(propertyName, value));
    }
    setSelectedValueText(value === 0 ? '' : ((_options$find = options.find(option => option.value === value)) === null || _options$find === void 0 ? void 0 : _options$find.text) || '');
    UsageTracker.track('filteredArticles', {
      screen: SCREENS.MANAGE,
      filteredBy: 'categories'
    });
  }, [options, removeQuickFilter, setQuickFilter]);
  const renderButtonContent = () => selectedValueText !== '' ? selectedValueText : I18n.text('knowledgeContentUI.properties.labels.hs_knowledge_category_name');
  return /*#__PURE__*/_jsx(Flex, {
    marginInline: "500",
    flexDirection: "row",
    alignItems: "end",
    justifyContent: "start",
    children: /*#__PURE__*/_jsx(Select, {
      buttonUse: "transparent",
      anchorType: "button",
      menuWidth: MENU_WIDTH_WIDE,
      ButtonContent: renderButtonContent,
      minimumSearchCount: 0,
      onChange: handleSelectCategory,
      options: options,
      placeholder: I18n.text(`${I18N_FILTER_PREFIX}.default`),
      value: selectedValue
    })
  });
};
export default ArticleCategoryFilter;